<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-body">
                <form >
                    <div class="form-body">
                        <h3 class="card-title">Crear/editar escalas Mmpi A</h3>
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Escala</label>
                                    <select id="scaleSelector" (change)="changeScale($event.target.value)" class="form-control custom-select">
                                        <option value="validez">Validez</option>
                                        <option value="clinicas">Clínicas</option>
                                        <option value="lingoes">Harris-Lingoes</option>
                                        <option value="contenido">Contenido</option>
                                        <option value="suplementarias">Suplementarias</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="type!='clinicas'" class="row p-t-20">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Valor <span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Cargando...</span> </label>
                                <select *ngIf="scales" class="form-control" [(ngModel)]="value" [ngModelOptions]="{standalone:true}">
                                    <option disabled value="">Seleccione escala...</option>
                                    <option *ngFor="let v of scalesArray" [value]="v.scale">A-{{v.scale}}</option>
                                </select>
                                <!-- <input [(ngModel)]="value" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Valor"> -->
                            </div>
                        </div>                        
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Titulo</label>
                                <input [(ngModel)]="title" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Título">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="type=='clinicas'" class="row p-t-20">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Valor <span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Cargando...</span> </label>
                                <select *ngIf="scales" class="form-control" [(ngModel)]="value" [ngModelOptions]="{standalone:true}">
                                    <option disabled value="">Seleccione escala...</option>
                                    <option *ngFor="let v of scalesArray" [value]="v.scale">A-{{v.scale=='Mf'?'MfV':v.scale}}</option>
                                </select>                            
                            </div>
                        </div>                     
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Título</label>
                                <input [(ngModel)]="subcategory" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Título">
                            </div>
                        </div>    
                        <button type="button" (click)="addSubcategory()" class="btn btn-primary btn-rounded waves-effect m-t-10">{{isEditing?'Actualizar':'Agregar'}}</button>
                    </div>
                    <div class="form-actions">
                        <button *ngIf="type!='clinicas'" type="button" (click)="addToScale()" class="btn btn-primary btn-rounded waves-effect">{{isEditing?'Actualizar':'Agregar'}}</button>
                        <!-- <button type="button" (click)="update()" class="btn btn-success btn-rounded waves-effect pull-right">Actualizar</button> -->
                    </div>
                </form>
                <div *ngIf="type" class="table-responsive m-t-20">
                    <h4 class="card-title">{{type.toUpperCase()}}</h4>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Valor</th>
                                    <th>Título</th>
                                    <th class="text-nowrap">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of scale; index as i">
                                    <td>A-{{row.value=='Mf'?'MfV':row.value}}</td>
                                    <td>{{row.title}}</td>
                                    <td class="text-center">
                                        <a href="javascript:void(0)" (click)="deleteScale(i, row._id)" data-toggle="tooltip" data-original-title="Borrar"> <i class="fa fa-close text-danger m-r-20"></i> </a>
                                        <a href="javascript:void(0)" (click)="handleEdit(row, i)"> <i class="fa text-dark fa-pencil"></i> </a>
                                    </td>
                                </tr>
                             </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade bs-example-modal-sm subModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Agregar valores</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="control-label">Valor</label>
                        <select *ngIf="scales>0" class="form-control" [(ngModel)]="value" [ngModelOptions]="{standalone:true}">
                            <option disabled value="">Seleccione subescala...</option>
                            <option *ngFor="let v of scales.all" [value]="v.scale">{{v.scale}}</option>
                        </select>  
                    </div>
                </div>                        
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="control-label">Titulo</label>
                        <input [(ngModel)]="title" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Título">
                    </div>
                </div>
                <button type="button" (click)="addToSubscale()" class="btn btn-primary btn-rounded waves-effect">Agregar</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>